import { getCookie } from '@client/services/cookies'

const cookieConsentName = 'gp_consent_privacy'

export const getLanguage = country => {
  const map = {
    br: 'pt-br',
    mx: 'es-mx',
    us: 'en-us',
    uk: 'en-uk',
  }

  return map[country] || 'en-us'
}

export const getConsentCookie = () => {
  return getCookie(cookieConsentName)
}
